
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impfaktion from '@/types/Impfaktion';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import {VForm, VDatePickerInput, VCurrencyField} from '@/types/Components';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import DatePickerInput from '@/components/DatePickerInput.vue';

    @Component({
        components: {
            DatePickerInput,
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('impfaktionen', ['impfaktionen', 'loaders', 'printers']),
            ...mapState('patientengruppen', ['gruppen']),
            ...mapState('patientengruppen', { gruppenLoaders: 'loaders'}),
            ...mapState('impfstoff', ['impfstoffe']),
            ...mapState('impfstoff', { impfstoffLoaders: 'loaders'}),
            ...mapState('leistungen', ['leistungen']),
            ...mapState('leistungen', { leistungLoaders: 'loaders'}),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('impfaktionen', ['updateImpfaktion', 'deleteImpfaktion', 'loadPrinters']),
            ...mapActions('patientengruppen', ['loadPatientengruppen']),
            ...mapActions('impfstoff', ['loadImpfstoffe']),
            ...mapActions('leistungen', ['loadLeistungen']),
        },
    })
    export default class ImpfaktionenDetail extends Vue {
        @Prop() impfaktion!: Impfaktion;
        @Prop() visible!: boolean;

        public updateImpfaktion!: (impfaktion: Impfaktion) => void;
        public deleteImpfaktion!: (impfaktion: Impfaktion) => void;
        public loadPatientengruppen!: () => void;
        public loadImpfstoffe!: () => void;
        public loadLeistungen!: () => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public impfaktione: any;
        public search = '';

        public $refs!: {
            form: VForm;
            von: VDatePickerInput;
            bis: VDatePickerInput;
            preis: VCurrencyField;
            preis_mitarbeiter: VCurrencyField;
            preis_rektorat: VCurrencyField;
        };

        public get isEdit(): boolean {
            return this.impfaktion.impfaktion_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.impfaktion.patientengruppen = [];
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                this.loadPatientengruppen();
                this.loadImpfstoffe();
                this.loadLeistungen();
                this.impfaktion.patientengruppen_alle = null;

                if (this.impfaktion.gueltig_extern === 'j') {
                    this.impfaktion.patientengruppen.push(1);
                }

                if (this.impfaktion.gueltig_muw_mitarbeiter === 'j') {
                    this.impfaktion.patientengruppen.push(2);
                }

                if (this.impfaktion.gueltig_muw_mitarbeiter_hcw === 'j') {
                    this.impfaktion.patientengruppen.push(3);
                }

                if (this.impfaktion.gueltig_muw_angehoerige === 'j') {
                    this.impfaktion.patientengruppen.push(4);
                }

                if (this.impfaktion.gueltig_medstudent === 'j') {
                    this.impfaktion.patientengruppen.push(5);
                }

                if (this.impfaktion.gueltig_medstudent_hcw === 'j') {
                    this.impfaktion.patientengruppen.push(6);
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateImpfaktion(this.impfaktion);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Impfaktion endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteImpfaktion(this.impfaktion);
                    }
                });
        }

        @Watch('impfaktion.patientengruppen_alle')
        public changeOnPatientengruppenAlle() {
            if (this.impfaktion.patientengruppen_alle === 'j') {
                this.impfaktion.gueltig_extern = 'j';
                this.impfaktion.gueltig_medstudent = 'j';
                this.impfaktion.gueltig_medstudent_hcw = 'j';
                this.impfaktion.gueltig_muw_angehoerige = 'j';
                this.impfaktion.gueltig_muw_mitarbeiter = 'j';
                this.impfaktion.gueltig_muw_mitarbeiter_hcw = 'j';
                this.impfaktion.patientengruppen = [];
            } else {
                this.impfaktion.gueltig_extern = null;
                this.impfaktion.gueltig_medstudent = null;
                this.impfaktion.gueltig_medstudent_hcw = null;
                this.impfaktion.gueltig_muw_angehoerige = null;
                this.impfaktion.gueltig_muw_mitarbeiter = null;
                this.impfaktion.gueltig_muw_mitarbeiter_hcw = null;
            }
        }

        @Watch('impfaktion.patientengruppen')
        public changeOnPatientengruppen() {
            if (this.impfaktion.patientengruppen_alle !== 'j') {
                if (this.impfaktion.patientengruppen.includes(1)) {
                    this.impfaktion.gueltig_extern = 'j';
                } else this.impfaktion.gueltig_extern = null;

                if (this.impfaktion.patientengruppen.includes(2)) {
                    this.impfaktion.gueltig_muw_mitarbeiter = 'j';
                } else this.impfaktion.gueltig_muw_mitarbeiter = null;

                if (this.impfaktion.patientengruppen.includes(3)) {
                    this.impfaktion.gueltig_muw_mitarbeiter_hcw = 'j';
                } else this.impfaktion.gueltig_muw_mitarbeiter_hcw = null;

                if (this.impfaktion.patientengruppen.includes(4)) {
                    this.impfaktion.gueltig_muw_angehoerige = 'j';
                } else this.impfaktion.gueltig_muw_angehoerige = null;

                if (this.impfaktion.patientengruppen.includes(5)) {
                    this.impfaktion.gueltig_medstudent = 'j';
                } else this.impfaktion.gueltig_medstudent = null;

                if (this.impfaktion.patientengruppen.includes(6)) {
                    this.impfaktion.gueltig_medstudent_hcw = 'j';
                } else this.impfaktion.gueltig_medstudent_hcw = null;
            }

            if (this.impfaktion.patientengruppen.length > 0 && this.impfaktion.patientengruppen.length !== 6) {
                this.impfaktion.patientengruppen_alle = 'n';
            }

            if (this.impfaktion.patientengruppen.length === 6) {
                this.impfaktion.patientengruppen_alle = 'j';
            }
        }
    }
